export enum SpecificPriceWithoutDiscounts {
  BasePrice = 'BasePrice',
  CompanySpecificBasePrice = 'CompanySpecificBasePrice',
  CompanySpecificSecondaryBasePrice = 'CompanySpecificSecondaryBasePrice',
  LocationSpecificBasePrice = 'LocationSpecificBasePrice',
  LocationSpecificSecondaryBasePrice = 'LocationSpecificSecondaryBasePrice'
}
